import dropPositions from '../constants/drop-positions';
import getLevelOfNesting from './get-level-of-nesting';
import { SORTABLE, NESTABLE } from '../constants/interaction-types';

const getDropPosition = (props, monitor, componentInstance) => {
  const { item: draggingItem } = monitor.getItem();
  const node = componentInstance.rootElement.current.querySelector('.ws-tree-view-item__wrapper');
  const { y, height } = node.getBoundingClientRect();
  const currentOffset = monitor.getClientOffset();
  const diff = currentOffset.y - y;
  const { nestingLevel, maxNestingLevel, interaction } = props;

  let dropAreaSize;

  switch (interaction) {
    case SORTABLE: {
      dropAreaSize = height / 2;
      break;
    }

    case NESTABLE: {
      /*
       * If dragging item has own nested items, we calculate level of nesting for case
       * when dragging element will be inserted to the current item, considering
       * current item level of nesting. It's necessary for prohibition or allowing
       * to drop dragging item inside current item.
       * */
      const assumedMaxLevelOfNesting = getLevelOfNesting(draggingItem.items, nestingLevel + 1);

      /*
       * If nesting level is less than max nesting level, item has 3
       * drop areas: before item, after item and inside. If nesting level is identical
       * to max nesting level then we do not allow to increase the level of nesting and
       * there is only 2 drop areas: before and after.
       *
       * By requirements, if item has 3 drop areas then top and bottom drop areas size
       * should be 20% of item height.
       * */

      dropAreaSize = assumedMaxLevelOfNesting <= maxNestingLevel ? height / 5 : height / 2;
      break;
    }
  }

  if (diff < dropAreaSize) {
    return dropPositions.BEFORE;
  }

  if (diff >= height - dropAreaSize) {
    return dropPositions.AFTER;
  }

  return dropPositions.INSIDE;
};

export default getDropPosition;
